<template>
    <div id="page">
        <div class="flex pad14 alc" id="toolH">
            <el-button :class="baseerp+'btn'"  size="small" type="primary" @click="gotoPage('add')">新增</el-button>
            <el-select  remote :remote-method="remoteMethodgk" style="margin-left: 10px" class="marr4" v-model="i_ckid" size="mini" @clear="cleardata('qs')" clearable filterable >
                <el-option
                        v-for="item in gkData"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-select   remote :remote-method="remoteMethodcom" class="marr4" v-model="i_company" size="mini" @clear="cleardata('com')"  clearable filterable >
                <el-option
                        v-for="item in comList"
                        :key="item.i_id"
                        :label="item.vc_name"
                        :value="item.i_id">
                </el-option>
            </el-select>
            <el-date-picker
                    style="width: 220px"
                    class="marr4"
                    size="mini"
                    v-model="valuetime"
                    @change="getTimes"
                    :clearable="false"
                    type="daterange"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期">
            </el-date-picker>
            <el-input
                    style="width: 220px;margin-left: 10px"
                    class="marr4"
                    size="mini"
                    placeholder="搜索"
                    clearable
                    v-model="vc_search">
            </el-input>
            <el-button class="marr4" icon="el-icon-search" circle  @click="gosearch" size="mini"></el-button>
            <!--<el-button :class="baseerp+'btn'"  size="small" type="primary" @click="toSave">保存</el-button>-->
        </div>
        <el-table
                v-loading="loading"
                ref="table"
                size="mini"
                border
                :data="tableData"
                :height="tableHeight"
                :header-cell-style="{background:'#eef1f6',color:'#000'}"
                :row-class-name="rowClassName">
            <el-table-column
                    type="index"
                    :label="$t('form_serial_number')">
            </el-table-column>
            <el-table-column
                    prop="vc_contract_number"
                    label="合同号"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_invoice_number"
                    label="发票号"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_buyer"
                    label="买方名称"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_buyer_po"
                    label="买方PO号"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_seller"
                    label="卖方名称"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_ckname"
                    :label="$t('form_warehouse')"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_target_company"
                    label="目的公司名称"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="dt_expire_time"
                    label="到期日"
                    width="150">
            </el-table-column>
            <el-table-column
                    prop="vc_product_type"
                    label="货物分类名"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_product"
                    label="货物名"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_unit"
                    label="计量单位"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_bz_symbol"
                    label="币种符号"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="vc_bzname"
                    label="币种"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="f_rate"
                    label="汇率"
                    width="80">
            </el-table-column>
            <el-table-column
                    prop="f_num"
                    label="数量"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="f_price"
                    label="成交价格"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="f_amount"
                    label="总额"
                    width="100">
            </el-table-column>
            <!--<el-table-column
                    prop="vc_trade_type"
                    label="贸易方式名"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_station_start"
                    label="起运港名"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_station_end"
                    label="目的港名"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_delivery"
                    label="交货"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_commodities_inspection"
                    label="商检"
                    width="150"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="vc_pay_type_cn"
                    label="付款方式中文"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_pay_type_en"
                    label="付款方式英文"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="i_has_account_period"
                    label="是否有账期"
                    width="100">
                <template slot-scope="scope" >
                    <span>{{scope.row.i_has_account_period==1?'是':'否'}}</span>
                </template>
            </el-table-column>
            <!--<el-table-column
                    prop="vc_tran_type"
                    label="运输方式"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>
            <el-table-column
                    prop="vc_shipmenttime"
                    label="出运日期要求"
                    width="200"
                    show-overflow-tooltip>
            </el-table-column>-->
            <el-table-column
                    prop="isuse"
                    label="是否有效"
                    width="100">
                <template slot-scope="scope" >
                    <span>{{scope.row.isuse==1?'是':'否'}}</span>
                </template>
            </el-table-column>
            <el-table-column
                    prop="vc_ywuname"
                    label="业务员"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="vc_lruname"
                    label="录入人"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="dt_createtime"
                    label="创建时间"
                    width="140">
            </el-table-column>
            <el-table-column
                    prop="vc_editname"
                    label="编辑人姓名"
                    width="100">
            </el-table-column>
            <el-table-column
                    prop="dt_edittime"
                    label="编辑时间"
                    width="140">
            </el-table-column>
            <el-table-column
                    width="120"
                    label="操作">
                <template slot-scope="scope">
                    <el-button  type="text" size="small" @click="goEdit(scope.row)">编辑</el-button>
<!--                    <el-button v-if="scope.row.i_target_company!=0" type="text" size="small" @click="sureDg(scope.row)">确认到港</el-button>-->
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
                class="fr mrr9 padT6"
                @size-change="handleSizeChange"
                @current-change="handleCurrentChange"
                :current-page.sync="currentPage"
                :page-sizes="[20, 30, 50]"
                :page-size="pageSize"
                layout="sizes, prev, pager, next"
                :total="tableTotal">
        </el-pagination>
        <div :class="baseerp+'div'" class="cgdia">
            <el-dialog
                    width="1100px"
                    :title="title"
                    :visible.sync="dialogVisible"
                    :close-on-click-modal="false"
                    @close="cancelDialog"
                    v-if="dialogVisible">
                <add-page :data="addData" @close="cancelDialog"></add-page>
            </el-dialog>
        </div>
        <!--<div :class="baseerp+'div'" class="cgdia">
            <el-dialog
                    width="400px"
                    title="确认到港"
                    :visible.sync="dialogVisible_dg"
                    :close-on-click-modal="false"
                    @close="cancelDialog_dg"
                    v-if="dialogVisible_dg">
                <div>{{'品名：'+this.row.vc_product}}</div>
                <div>{{'数量：'+this.row.f_num}}</div>
                <div class="flex">
                    {{'到港时间：'}}
                    <el-date-picker
                            v-model="dt_arrival_time"
                            size="mini"
                            class="changeinput"
                            format="yyyy-MM-dd"
                            value-format="yyyy-MM-dd"
                            type="date"
                            placeholder="到港时间"
                    >
                        &lt;!&ndash;:picker-options="pickerOptions"&ndash;&gt;
                    </el-date-picker>
                </div>
                <el-button type="text" size="small" @click="gotoSuredg">确认</el-button>
            </el-dialog>
        </div>-->

    </div>

</template>

<script>
    import * as API from "./api";
    import {mapActions} from "vuex";
    import {baseerp} from "@/utils/baseUrl";
    import {file_root} from "@/utils/baseUrl";
    import addPage from "./addPage";
    export default {
        components: {
            addPage
        },
        data() {
            return {
                valuetime:'',
                dt_startdate:'',
                dt_enddate:'',
                i_company:0,
                i_ckid:0,
                gkData:[],
                comList:[],
                row:{},
                dt_arrival_time:"",
                khList:[],
                nalList:[],
                nalList2:[],
                i_national:0,
                vc_national:'全部',
                vc_search:"",
                addData:{},
                title:'新增',
                dialogVisible:false,
                dialogVisible_dg:false,
                pageSize:30,
                currentPage:1,
                tableTotal:0,
                baseerp:"",
                file_root:"",
                mid:0,
                tableData:[
                    {
                        "vc_contract_number": "CT20231001001", // 合同号
                        "vc_invoice_number": "INV20231001001", // 发票号
                        "vc_ywuname": "业务员", //业务员
                        "i_buyer": 1001, // 买方id
                        "vc_buyer": "示例买方公司", // 买方名称
                        "vc_buyer_po": "PO20231001001", // 买方PO号
                        "i_seller": 1001, // 卖方id
                        "vc_seller": "示例卖方公司", // 卖方名称
                        "i_target_company": 1001, //目的公司id
                        "vc_target_company": "目的公司名称", // 目的公司名称
                        "dt_signtme": "2023-10-01", // 签约日期
                        "i_product_type": 1, // 货物分类id
                        "vc_product_type": "氯化胆碱", // 货物分类名
                        "i_product": 101, // 货物id
                        "vc_product": "70粉剂普货", // 货物名
                        "f_num": 10.50000, // 吨位
                        "f_price": 1000.50000000, // 合同单价
                        "i_bzid": 1, // 币种id
                        "vc_bz_symbol": "CNY", // 币种符号
                        "f_rate": 1.00, // 汇率
                        "f_amount": 10505.00, // 总额
                        "i_trade_type": 1, // 贸易方式id
                        "vc_trade_type": "CFR", // 贸易方式名
                        "i_station_start": 10001, // 起运港id
                        "vc_station_start": "上海港", // 起运港名
                        "i_station_end": 20001, // 目的地id
                        "vc_station_end": "纽约港", // 目的地名
                        "vc_delivery": "TAIAN,CHINA", // 交货
                        "vc_commodities_inspection": "泰安", // 商检
                        "i_pay_type": 1, // 付款方式
                        "vc_pay_type_cn": "60天可融资", // 付款方式中文
                        "vc_pay_type_en": "TT60days againts BL date", // 付款方式英文
                        "i_has_account_period": 1, // 是否有账期，1是0否
                        "i_tran_type": 1, // 运输方式
                        "vc_tran_type": "By Sea", // 运输方式
                        "vc_shipmenttime": "12月中下", // 出运日期要求
                        "vc_filejson": "", // 附件JSON
                        "isuse": 1, // 1有效，0已作废
                        "i_lruid": 101, // 录入人id
                        "vc_lruname": "张三", // 录入人名字
                        "dt_createtime": "2023-10-01", // 创建时间
                        "i_edituid": 102, // 编辑人id
                        "vc_editname": "李四", // 编辑人姓名
                        "dt_edittime": "2023-10-02" // 编辑时间
                    }
                ],
                loading:false,
                tableHeight:0,
            }
        },
        watch: {
            '$root.workSize':{
                handler(n,o) {
                    // console.log(n,12312312)
                    this.onResize(n);
                },
                deep:true,
            },
        },
        activated(){
            //this.onResize();
        },
        mounted() {
            this.baseerp=baseerp;
            this.file_root = file_root;
            //this.nationalList(1,'');
            //this.nationalList(2,'');
            //this.khtypeList();
            this.getfMou();
            this.getPortList('')
            this.companylist('')

            this.$nextTick(function () {
                this.onResize();
            });
        },
        methods:{
            ...mapActions(["getCurrentMenuId"]),
            onResize(n){
                if (n==undefined) n=this.$root.workSize;
                this.tableHeight = n.h - 100;
                //this.tableHeight = $("#page").height()*1 -  $("#toolH").height()*1 ;
                //console.log(n.h,this.tableHeight)
            },
            //获取当天日期
            getDateYYYYMMddHHMMSS(){
                const date = new Date();
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const strDate = date.getDate().toString().padStart(2, '0');
                return `${date.getFullYear()}-${month}-${strDate}`
            },
            cancelDialog_dg(type='back'){
                if(type=='save'){
                    this.currentPage=1
                    this.getlist();
                }
                this.dialogVisible_dg=false;
            },
            sureDg(row){
                this.dialogVisible_dg=true;
                this.row=row;
                this.dt_arrival_time=this.getDateYYYYMMddHHMMSS();
            },
            gotoSuredg(){
                let map={
                    "i_id": 0,
                    "i_inckid": this.row.i_station_end, //仓库id
                    "vc_inckname": this.row.vc_station_end, //入库仓库名
                    "i_outckid": 0, //仓库id
                    "vc_outckname": "", //出库仓库名
                    "i_company":  this.row.i_target_company,
                    "vc_company": this.row.vc_target_company,
                    "i_ywid":this.row.i_id, //业务id，到港确认时存储外销成本预估id
                    "i_type": 1, //类型id
                    "vc_type": "采购入库", //类型
                    "i_product_type": this.row.i_product_type, // 货物分类id
                    "vc_product_type": this.row.vc_product_type,// 货物分类名
                    "i_product": this.row.i_product, // 货物id
                    "vc_product": this.row.vc_product,// 货物名
                    "f_num": this.row.f_num,// 数量
                    "vc_unit":this.row.vc_unit, // 单位
                    'dt_arrival_time':this.dt_arrival_time,
                }
                this.inventorysave(map);
            },
            async inventorysave(map){
                this.loading=true;
                let arr=[];
                arr.push(map);
                let param={
                    list:arr,
                };
                let res=await API.inventorysave(param);
                if(res.code==1){
                    this.dialogVisible_dg=false;
                    this.$message.success(res.message);
                    this.loading=false;
                    this.getlist();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.getlist();
                    this.$message.error(res.message);
                }
            },
            /*toSave(){
                let arr=[];
                arr=this.tableData.filter(item=>{
                    return item.edit==true
                })
                console.log(arr,'arr')
                this.save(arr);
            },
            //
            async save(arr){
                this.loading=true;
                let param={
                    list:arr,
                };
                let res=await API.save(param);
                if(res.code==1){
                    this.$message.success(res.message);
                    this.loading=false;
                    this.getlist();
                }else if (res.code == -2) {
                    this.loading=false;
                    this.$router.push('/login');
                    this.$message.error(res.message);
                } else{
                    this.disabled=false;
                    this.loading=false;
                    this.getlist();
                    this.$message.error(res.message);
                }
            },*/
            gosearch(){
                //console.log("搜索",this.vc_search);
                //console.log("公司",this.companyId);
                this.currentPage=1;
                this.tableData=[];
                this.getlist();
            },
            cancelDialog(type='back'){
                if(type=='save'){
                    this.currentPage=1
                    this.getlist();
                }
                this.dialogVisible=false;
            },
            goEdit(row){
                this.title='编辑';
                this.addData=row;
                this.dialogVisible=true;
                /*row.edit=true;
                this.$set(data,index,row)*/
            },
            gotoPage(type){
                /*let map={
                    i_id:0,
                    isuse:1,
                    edit:true,
                }
                this.tableData.push(map);*/
                this.title='新增';
                if(type=='add'){
                    this.addData={
                        i_id:0,
                    }
                }
                this.dialogVisible=true;
            },
            handleSizeChange(val){
                this.pageSize=val;
                this.currentPage=1;
                this.getlist()
            },
            handleCurrentChange(val){
                this.currentPage=val;
                this.getlist()
            },

            /*remoteMethodkh(val){
                this.nationalList(1,val);
            },
            remoteMethodkh2(val){
                this.nationalList(2,val);
            },*/
            rowClassName({row,rowIndex}){
                row.index=rowIndex
                // console.log(row, row.index,'rowClassName')
            },
            /*changekhData(e){
                console.log(e.index);
                if(this.khList.length!=0){
                    let choo = this.khList.filter(item=>{
                        return item.vc_name == e.vc_type
                    });
                    console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].vc_type=choo[0].vc_name;
                        this.tableData[e.index].i_type=choo[0].i_id;
                    }else{
                        this.tableData[e.index].vc_type='';
                        this.tableData[e.index].i_type=0;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }
            },
            cleardatagb(){
                this.nationalList(1,'');
            },
            cleardata(e){
                console.log(e,'e')
                this.nationalList(2,'')
            },
            changegbData(e){
                console.log(e);
                if(this.nalList2.length!=0){
                    let choo = this.nalList2.filter(item=>{
                        return item.vc_name == e.vc_national
                    });
                    console.log(choo)
                    if(choo.length>0){
                        this.tableData[e.index].vc_national=choo[0].vc_name;
                        this.tableData[e.index].i_national=choo[0].i_id;
                    }else{
                        this.tableData[e.index].vc_national='';
                        this.tableData[e.index].i_national=0;
                    }
                    this.$nextTick(()=>{
                        this.$forceUpdate()
                    })
                }
            },
            //下拉框国别
            async nationalList(type,val){
                let param = {
                    i_mid:this.mid,
                    vc_search:val,
                    currentPage:1,
                    pageSize:50,
                    isuse:1,
                };
                /!*let res={
                    code:1
                }*!/
                let res = await API.nationalList(param);
                if (res.code == 1) {
                    if(type==1){
                        //this.nalList=[{i_id:1,vc_name:'数税云'},{i_id:2,vc_name:'线下'},{i_id:0,vc_name:'全部'}];
                        this.nalList = res.data.list;
                        this.nalList.unshift({i_id:0,vc_name:'全部'});
                    }
                    if(type==2){
                        //this.nalList=[{i_id:1,vc_name:'数税云'},{i_id:2,vc_name:'线下'},{i_id:0,vc_name:'全部'}];
                        this.nalList2 = res.data.list;
                    }
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //
            async khtypeList(){
                let param = {
                    i_mid:this.mid,
                    isuse:1,
                };
                /!*let res={
                    code:1
                }*!/
                let res = await API.khtypeList(param);
                if (res.code == 1) {
                    //this.khList=[{i_id:1,vc_name:'数税云'},{i_id:2,vc_name:'线下'},{i_id:0,vc_name:'全部'}];
                    this.khList = res.data.list;
                } else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },*/
            remoteMethodgk(val){
                this.getPortList(val)
            },
            remoteMethodcom(val){
                this.companylist(val)
            },
            //公司列表
            async companylist(val){
                let param={
                    i_mid:this.mid,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                    isuse:1,
                };
                let res=await API.companylist(param);
                if(res.code==1){
                    this.comList=res.data.list;
                    this.comList.unshift({i_id:0,vc_name:'全部'});
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            //港口列表
            async getPortList(val){
                let param={
                    i_mid:this.mid,
                    //i_type:2,
                    i_type:1,
                    currentPage:1,
                    pageSize:50,
                    vc_search:val,
                };
                //console.log(param,'param');
                let res=await API.warehouselist(param);
                if(res.code==1){
                    this.gkData=res.data.list;
                    this.gkData.unshift({i_id:0,vc_name:'全部'});
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }
                else{
                    this.$message.error(res.message);
                }
            },
            async getlist(){
                let result = await this.getCurrentMenuId({path: this.$route.path});
                // console.log("result",result)
                if (result.i_id !== "") {
                    this.mid = result.i_id;
                    sessionStorage.setItem('mids', result.i_id)
                } else {
                    this.mid = sessionStorage.getItem('mids')
                }
                let param={
                    i_mid:this.mid,
                    currentPage:this.currentPage,
                    pageSize:this.pageSize,
                    vc_search:this.vc_search,
                    i_ckid:this.i_ckid,
                    i_company:this.i_company,
                    dt_startdate:this.dt_startdate,
                    dt_enddate:this.dt_enddate,
                    i_type:3,
                };
                //console.log(param,'param');
                let res=await API.selllist(param);
                if ( res.code == 1 ){
                    /*res.data.list.map(item=>{
                        item.edit=true;
                    })*/
                    this.tableData=res.data.list;
                    this.total=res.data.total
                }else if (res.code == -2) {
                    this.$router.push('/login');
                    this.$message.error(res.message);
                }else{
                    this.$message.error(res.message);
                }
            },
            //获取当前月的第一天
            getfMou(){
                let today = new Date();
                let firstDay = new Date(today.getFullYear(), today.getMonth(), 1);
                //console.log(firstDay,today);
                let map = [firstDay,today];
                this.valuetime=map;
                //console.log(this.valuetime)
                this.dt_startdate= this.formatDate( this.valuetime[0]);
                this.dt_enddate= this.formatDate( this.valuetime[1]);
                this.getlist();
            },
            formatTen(num) {
                return num > 9 ? (num + "") : ("0" + num);
            },
            formatDate(date) {
                var year = date.getFullYear();
                var month = date.getMonth() + 1;
                var day = date.getDate();
                var hour = date.getHours();
                var minute = date.getMinutes();
                var second = date.getSeconds();
                return year + "-" + this.formatTen(month) + "-" + this.formatTen(day);
            },
            getTimes(e){
                //console.log(e)
                if(e){
                    this.dt_startdate= this.formatDate(e[0]);
                    this.dt_enddate= this.formatDate(e[1]);
                    //console.log(this.dt_startdate,this.dt_enddate);
                }else{
                    this.dt_startdate= '';
                    this.dt_enddate= '';
                }
                this.currentPage=1;
                this.tableData=[];
                this.getlist();
            },
        },
    }
</script>

<style  lang="scss" scoped>

    .alc{
        align-items: center;
    }
    .font14{
        font-size: 14px;
        color: grey;
        min-width:58px;
    }
    .flex_b{
        display: flex;
        justify-content: space-between;
    }
    .flex{
        display: flex;
    }
    .fr{
        float: right;
    }
    .mrr9{
        margin-right: 9px;
    }
    .padT6{
        //padding: 6px 0;
    }
    .pad14{
        padding: 3px 9px;
    }
    .w100{
        width: 100%;
    }
    .marr4{
        margin-right: 4px;
    }
</style>